const AUTH_ROOT = '/auth';

export const AUTH_SESSION_ENDPOINTS = {
  getMe: `${AUTH_ROOT}/get-me`,
  refreshJwt: `${AUTH_ROOT}/refresh-jwt`,
  freshJwt: `${AUTH_ROOT}/fresh-jwt`,
  accessRevoke: `${AUTH_ROOT}/access-revoke`,
  refreshRevoke: `${AUTH_ROOT}/refresh-revoke`,
  fullRevoke: `${AUTH_ROOT}/full-revoke`,
  logout: `${AUTH_ROOT}/logout`,
  login: `${AUTH_ROOT}/login`,
  validatePassword: `${AUTH_ROOT}/validate-password`,
  validateBiometry: `${AUTH_ROOT}/validate-biometry`,
};

export const AUTH_BIOMETRY_ENDPOINTS = {
  addNew: `${AUTH_ROOT}/biometry/add-new`,
  removeBiometry: `${AUTH_ROOT}/biometry/remove-biometry`,
};

export const AUTH_PERMISSION_ENDPOINTS = {
  routeMap: `${AUTH_ROOT}/permissions/route-map`,
};

export const AUTH_REGISTER_ENDPOINTS = {
  editPersonalData: `${AUTH_ROOT}/register/edit-personal-data`,
  updateSignedDocuments: `${AUTH_ROOT}/register/update-signed-documents`,
};

export const AUTH_CHANGE_EMAIL_ENDPOINTS = {
  main: `${AUTH_ROOT}/change-email/main`,
  checkCode: `${AUTH_ROOT}/change-email/check-code`,
};

export const AUTH_CHANGE_PHONE_ENDPOINTS = {
  requestCode: `${AUTH_ROOT}/change-phone/request-code`,
  validateCode: `${AUTH_ROOT}/change-phone/validate-code`,
};

export const AUTH_FORGOT_PASSWORD_ENDPOINTS = {
  mainNotLoggedIn: `${AUTH_ROOT}/forgot-password/main-not-logged-in`,
  main: `${AUTH_ROOT}/forgot-password/main`,
  validateCodeNotLoggedIn: `${AUTH_ROOT}/forgot-password/validate-code-not-logged-in`,
  validateCode: `${AUTH_ROOT}/forgot-password/validate-code`,
};

export const AUTH_PASSWORD_ENDPOINTS = {
  check: `${AUTH_ROOT}/password/check`,
  update: `${AUTH_ROOT}/password/update`,
  setInitial: `${AUTH_ROOT}/password/set-initial`,
};

export const AUTH_NOTIFICATION_ENDPOINTS = {
  getAll: `${AUTH_ROOT}/notifications/get-all`,
  update: `${AUTH_ROOT}/notifications/update`,
};

export const AUTH_REFERRAL_ENDPOINTS = {
  sendMessage: `${AUTH_ROOT}/referrals/send-message`,
};

export const AUTH_ENDPOINTS = {
  biometry: AUTH_BIOMETRY_ENDPOINTS,
  changeEmail: AUTH_CHANGE_EMAIL_ENDPOINTS,
  changePhone: AUTH_CHANGE_PHONE_ENDPOINTS,
  forgotPassword: AUTH_FORGOT_PASSWORD_ENDPOINTS,
  notifications: AUTH_NOTIFICATION_ENDPOINTS,
  password: AUTH_PASSWORD_ENDPOINTS,
  permissions: AUTH_PERMISSION_ENDPOINTS,
  referrals: AUTH_REFERRAL_ENDPOINTS,
  register: AUTH_REGISTER_ENDPOINTS,
  session: AUTH_SESSION_ENDPOINTS,
};
